export { default } from "./FinderHead";
